import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import {
  getSchemaReviewResultMulti,
  getReviewResultMutiData,
  getSchemaReviewSummary,
} from '../../../redux/actions/reviewSummary'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ProjectDataTable from '../../../widgets/dataTable/ProjectDataTable'
import scrollToComponent from 'react-scroll-to-component'
import { Message, Row } from 'rsuite'
import ReviewResult from '../../../widgets/reviewSummary/ReviewResult'
import { useDispatch, useSelector } from 'react-redux'
import { getSchemaMultiReviewSidebar } from '../../../redux/actions/sidebar'
import pathname from '../../../constants/pathname'

export default function ReviewResultsMulti() {
  const [isLoading, setIsLoading] = useState(false)
  const [isReLoading, setIsReLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [reviewSummary, setReviewSummary] = useState()
  const [section, setSection] = useState()
  const [dataTableSection, setDataTableSection] = useState()
  const [singleProject, setSingleProject] = useState()
  const [singleError, setSingleError] = useState()
  const [requestBody, setRequestBody] = useState()
  const [projectList, setProjectList] = useState()
  const [projectIdList, setProjectIdList] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const history = useHistory()
  // const projectId = '0219B95A-097A-444C-B903-7F39EBBBA6EE'
  const dispatch = useDispatch()

  useEffect(() => {
    getRequestBody()
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      // let request = getRequestBody()
      let request = {
        groupId: projectId,
      }
      // console.log('handleGetSchema request', request)
      setReviewSummary('')
      setSingleProject('')
      const _schema = await getSchemaReviewResultMulti(request, 5, 1)
      console.log('handleGetSchema response', _schema)
      setSchema(_schema)
      setProjectList(_schema?.forms?.projectList)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSingleSubmit = async (obj) => {
    console.log('obj', obj)
    setSingleError(false)
    startLoading()
    try {
      setReviewSummary('')
      setSingleProject(obj)
      const response = await getSchemaReviewSummary(obj.id)
      console.log('response', response)

      let _schema = response?.model?.forms?.ReviewerSummary
      console.log('_schema', _schema)
      if (_schema) {
        _schema['header'] = obj.projectName
        setReviewSummary(_schema)
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      } else {
        setSingleError(true)
      }
    } catch (e) {
      console.log('e', e)
      setSingleError(true)
    }

    doneLoading()
  }

  const handleReload = async (pagesize, pagenumber) => {
    setIsReLoading(true)
    startLoading()
    try {
      // let request = getRequestBody()
      let request = {
        groupId: projectId,
      }
      console.log('handleReload request', request, 'pagesize', pagesize, 'pagenumber', pagenumber)
      setReviewSummary('')
      setSingleProject('')
      const response = await getReviewResultMutiData(request, pagesize, pagenumber)
      setProjectList(response)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsReLoading(false)
  }

  const onMultiComplete = async (_schema, projectVersionIdList) => {
    sessionStorage.setItem('projectId', projectId)
    // history.push(`${pathname.proposal.review.paymentSaveMulti}/${projectId}`)
    history.push(`${pathname.proposal.review.paymentSaveMulti}`)
  }

  const onComplete = async (_schema, projectVersionIdList) => {
    let idListStr = sessionStorage.getItem('mutiReview')
    let responseId = _schema.projectVersionId || _schema.model?.projectVersionId || ''

    console.log('idListStr : ', idListStr, 'responseId : ', responseId)

    let responseIdList = responseId?.split(',')

    if (projectVersionIdList?.length == responseIdList?.length) {
      let index = 0
      for (var projectVersionId in projectVersionIdList) {
        idListStr?.replace(projectVersionId, responseIdList[index])

        index++
      }
    }

    console.log('after IdListStr : ', idListStr)
    sessionStorage.setItem('mutiReview', idListStr)

    setRequestBody()
    setReviewSummary('')

    scrollToComponent(dataTableSection, { offset: 0, align: 'top', duration: 500 })
    handleReload(5, 1)
    //await handleGetSchema()
    await dispatch(getSchemaMultiReviewSidebar(projectId))
  }

  const getRequestBody = () => {
    let request = requestBody
    if (!request) {
      let idList = sessionStorage.getItem('mutiReview')
      request = {
        id: idList,
      }
    }

    setProjectIdList(request.id.split(','))
    setRequestBody(request)
    return request
  }

  if (error) {
    return (
      <SidebarProposal isMultiReview>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isMultiReview>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isMultiReview>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      {schema?.forms?.reviewResult && (
        <div>
          <ReviewResult
            schema={schema.forms.reviewResult}
            onComplete={onMultiComplete}
            projectVersionIdList={projectIdList}
          />
        </div>
      )}

      <Row
        ref={(section) => {
          setDataTableSection(section)
        }}
      ></Row>

      {projectList && (
        <>
          <ProjectDataTable
            schema={projectList}
            single={{
              enable: true,
              buttonText: projectList.buttonText || 'บันทึกผลการกลั่นกรอง',
              iconByStatus: true,
              hideText: false,
              width: 210,
            }}
            onSingleSubmit={onSingleSubmit}
            pagination={true}
            onReload={handleReload}
            loading={isReLoading}
          />
          <br />
        </>
      )}

      <Row
        ref={(section) => {
          setSection(section)
        }}
      >
        {singleError && (
          <>
            <Message
              showIcon
              type="error"
              description={`ดึงข้อมูลโครงการ ${singleProject?.projectName} ไม่สำเร็จ`}
            />
            <br />
          </>
        )}
      </Row>

      {reviewSummary && (
        <div>
          <ReviewResult
            schema={reviewSummary}
            onComplete={onComplete}
            projectVersionIdList={[singleProject.id]}
          />
        </div>
      )}
    </SidebarProposal>
  )
}
